@for (waitListEntry of waitListEntries$ | async; track waitListEntry) {
  <div class="kgr-alert kgr-alert--prominentInfo kgr-alert--fullWidth kgr-row kgr-row--noneIfLastChild">
    <div class="kgr-headline kgr-headline--h4 kgr-headline--text kgr-headline--firstInText">
      <ng-container i18n>Warteliste</ng-container>: {{ waitListEntry.appointmentTitle }}
    </div>
    <div class="kgr-row">
      <div class="kgr-row" i18n>
        Es ist ein Platz für <b class="kgr-text kgr-text--bold">{{ waitListEntry.member.fullName }}</b> frei geworden.
      </div>

      <ng-container i18n>
        Platz buchen

        <b class="kgr-text kgr-text--bold"
          >bis {{ waitListEntry.reservedUntil | date: 'shortDate' }} {{ waitListEntry.reservedUntil | date: 'shortTime' }} Uhr</b
        >, anschließend verfällt der Wartelistenplatz.
      </ng-container>
    </div>
    <a
      [routerLink]="['offerings' | appContextRoute | async, waitListEntry.offeringType === 'course' ? 'courses' : 'generic-offerings']"
      [queryParams]="{ appointmentSeriesId: waitListEntry.appointmentSeriesId, start: waitListEntry.appointmentStart }"
      queryParamsHandling="merge"
      class="kgr-button kgr-button--accent"
      i18n
    >
      zur Angebotsbuchung
    </a>
  </div>
}
